import * as base64url from "./base64url";

export async function passkeyCredential(type: "get" | "create", authOptions): Promise<{ err: boolean; data: any }> {
  try {
    if (typeof authOptions === "string") {
      authOptions = JSON.parse(authOptions);
    }
    console.log(type + " passkeyCredential authOptions =", authOptions);

    const option = { ...authOptions };
    option.challenge = base64url.decodeBase64url(option.challenge);
    if (option.excludeCredentials && option.excludeCredentials.length) {
      option.excludeCredentials.map((obj) => {
        obj.id = base64url.decodeBase64url(obj.id);
      });
    }
    if (type === "get") {
      if (option.allowCredentials && option.allowCredentials.length) {
        option.allowCredentials.map((obj) => {
          obj.id = base64url.decodeBase64url(obj.id);
        });
      }
      // option.allowCredentials[0].id = base64url.decodeBase64url(option.allowCredentials[0].id);
    } else if (type === "create") {
      option.user.id = base64url.decodeBase64url(option.user.id);
    }
    console.log(type + " passkeyCredential option =", option);

    const credential: any = await navigator.credentials[type]({
      publicKey: option,
    });
    console.log(type + " passkeyCredential credential =", credential);

    const convertObj: any = {
      authenticatorAttachment: credential.authenticatorAttachment,
      rawId: base64url.encodeBase64url(new Uint8Array(credential.rawId)),
      type: credential.type,
      id: credential.id,
      response: {
        clientDataJSON: base64url.encodeBase64url(new Uint8Array(credential.response.clientDataJSON)),
      },
    };
    if (type === "get") {
      convertObj.response.signature = base64url.encodeBase64url(new Uint8Array(credential.response.signature));
      convertObj.response.authenticatorData = base64url.encodeBase64url(new Uint8Array(credential.response.authenticatorData));
    } else if (type === "create") {
      convertObj.response.attestationObject = base64url.encodeBase64url(new Uint8Array(credential.response.attestationObject));
    }
    console.log(type + " passkeyCredential convertObj =", convertObj);

    return { err: false, data: JSON.stringify(convertObj) };
  } catch (e) {
    console.log(type + " passkeyCredential error =", e);
    return { err: true, data: e };
  }
}

export async function getPasskeyCredential(authOptions): Promise<{ err: boolean; data: any }> {
  return passkeyCredential("get", authOptions);
}

export async function createPasskeyCredential(authOptions): Promise<{ err: boolean; data: any }> {
  return passkeyCredential("create", authOptions);
}
